import React, { useRef } from "react";
import _ from "lodash";
import TYPE from "../../../../constant/TYPE";
import { getMathJaxNode } from "../../mathjax/MathJax";
import ProcessRoot from "./ProcessRoot";
import Process from "./Process";

const PrimeFactorization = ( props ) => {

  const prevData = useRef( [] );
  const mathjaxRenderCount = useRef( 0 );

  const startKeyword = `\\begin{${ TYPE.LATEX_CODE.PRIME_FACTORIZATION }}`;
  const endKeyword = `\\end{${ TYPE.LATEX_CODE.PRIME_FACTORIZATION }}`;

  const mapData = ( value, index ) => {
    if ( index ) {
      const keyword = '\\\\';
      return value.slice( value.indexOf( keyword ) + keyword.length ).trim();
    } else {
      const keyword = '\\begin{array}';
      return value.slice( value.indexOf( keyword ) + keyword.length ).split( '\\\\' ).map( v => v.split( '&' ).map( v => v.trim() ) );
    }
  };

  const data = props.children.slice( props.children.indexOf( startKeyword ) + startKeyword.length, props.children.indexOf( endKeyword ) ).split( '\\end{array}' ).map( mapData );

  const reduceChangedDataCount = ( result, value, index ) => {
    let count;
    if ( index ) {
      count = prevData.current[ index ] === value ? 0 : 1;
    } else {
      count = value.filter( ( v, i ) => ! _.isEqual( prevData.current[ index ] && prevData.current[ index ][ i ], v ) ).length;
    }
    return result + count;
  };

  const changedDataCount = data.reduce( reduceChangedDataCount, 0 );

  const MathJaxNode = getMathJaxNode( props.type );

  const mapRows = ( value, index ) => {
    if ( index ) {
      return <div key={ index } className="mt20 ta-l"><MathJaxNode onRender={ renderMathJax }>{ value }</MathJaxNode></div>;
    } else {
      return value.map( mapColumns );
    }
  };

  const mapColumns = ( value, index ) => {
    const Column = index ? Process : ProcessRoot;
    return <Column key={ index } index={ index } type={ props.type } data={ value } onRender={ renderMathJax } />;
  };

  const renderMathJax = () => {
    mathjaxRenderCount.current++;
    if ( changedDataCount === mathjaxRenderCount.current ) {
      prevData.current = data;
      mathjaxRenderCount.current = 0;
      props.onRender();
    }
  };

  const ROWS = data.map( mapRows );

  return <div>{ ROWS }</div>;

};

export default PrimeFactorization;
